import store from "@/store";
import router from "@/router";
import {toast} from "./Notification";

export const basketAddItem = (product, sub_product) => {
    if (store.getters['User/isAuthenticated'] == false) {
        toast("خطا", "برای اضافه کردن محصول به سبد ابتدا باید ثبت نام کنید", 'danger');
    } else {
        let form;
        if (product.variation == 1) {
            form = {product: [{id: product.id, sub_product: sub_product.id}]};
        } else {
            form = {product: [{id: product.id}]};
        }

        store.dispatch("ShoppingCart/addItem", form)
        if (product.is_digital == 1) {
            router.push({'name': 'ShoppingCart'});
        }
    }
}

export const addUnAuthItem = (product, sub_product) => {
    store.dispatch("ShoppingCart/addUnAuthItem", {product, sub_product}).then(() => {
        if (product.is_digital == 1) {
            router.push({'name': 'UnAuthenticatedShoppingCart'});
        }
    })

}